// extracted by mini-css-extract-plugin
module.exports = {"projectsCount":"ProjectsCount_projectsCount__3jQsd","number":"ProjectsCount_number__GP5M2"};